import { NgModule } from '@angular/core';
import { Http } from '@angular/http';
import { LocalStorageService } from 'angular-2-local-storage';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { AppTranslateService } from './../translations/services/app-translation.service';
import { MissingTranslationHandler } from '@ngx-translate/core';
import { MyMissingTranslationHandler } from './../translations/services/app-missingTranslation.service';
import { CacheKey } from '../shared/constants/cachekey.constants';

export function createTranslateLoader(http: Http) {
  // return new TranslateHttpLoader(http, 'src/app/test/', '.json');
  return new AppTranslateService(http);
}

const translationOptions = {
  loader: {
    provide: TranslateLoader,
    useFactory: (createTranslateLoader),
    deps: [Http, LocalStorageService]
  },
  missingTranslationHandler: {
    provide: MissingTranslationHandler,
    useClass: MyMissingTranslationHandler
  }

};

@NgModule({
  imports: [TranslateModule.forRoot(translationOptions)],
  exports: [TranslateModule],
  providers: [TranslateService]
})
export class AppTranslationModule {
  language: any;
  defaultlang: any;
  constructor(private translate: TranslateService, private localStorageService: LocalStorageService) {
    this.defaultlang = this.localStorageService.get(CacheKey.DefaultLanguage);
    this.language = this.localStorageService.get(CacheKey.Language);
    if (this.language != null && this.language != undefined) {
      this.translate.use(this.language);
    }
    else if(this.defaultlang !=null  && this.defaultlang != undefined)
    { this.translate.use(this.defaultlang); }
  }
}


// WEBPACK FOOTER //
// ./src/app/translations/app-translations.module.ts